/**
 * Created by mickle.jiang on 2017/9/14.
 */
/**
 * LocalStorge操作封装
 * @type {{getLocalStorge: getLocalStorage.getLocalStorge, setItem: getLocalStorage.setItem, getItem: getLocalStorage.getItem,
    * removeItem: getLocalStorage.removeItem,clearItem:getLocalStorage}}
    */
   let LocalStorageUtils = {
     /**
      * 从windows对象中获取LocalStorge操作封装
      * @param window
      * @return {Storage}
      */
     getLocalStorage: function (window) {
       return window.localStorage
     },
     /**
      * 设置值
      * @param window
      * @param key
      * @param value
      */
     setItem: function (window, key, value) {
       this.getLocalStorage(window).setItem(key, value)
     },
     /**
      * 根据键获取值
      * @param window
      * @param key
      * @param defaultValue
      * @return {*}
      */
     getItem: function (window, key, defaultValue) {
       let res = this.getLocalStorage(window).getItem(key)
       if (res === undefined || res === null) {
         return defaultValue
       }
       return res
     },
     /**
      * 根据键移除值
      * @param window
      * @param key
      */
     removeItem: function (window, key) {
       this.getLocalStorage(window).removeItem(key)
     },
     /**
      * 清空
      * @param window
      */
     clearItem: function (window) {
       this.getLocalStorage(window).clear()
     }
   }
   
   export default LocalStorageUtils
   


// WEBPACK FOOTER //
// ./src/libs/LocalStorageUtils.js